<template>
  <span
    ><span @click="isOpen = true" class="ui-text-clickable">New Contact</span>
    <hi-dialog
      v-model="isOpen"
      @submit="submit"
      width="800px"
      title="Add New Contact"
    >
      <v-form v-model="valid" ref="form">
        <v-container>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="name"
                :rules="nameRules"
                label="First name"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="midName"
                label="Middle name"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="surname" label="Surname"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="phone"
                :rules="phoneRules"
                label="Phone number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="group"
                :items="contactGroups"
                item-text="label"
                item-value="value"
                label="Group"
                required
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="error">{{ error }}</v-row>
        </v-container>
      </v-form>
    </hi-dialog>
  </span>

  <!--        <v-btn color="primary" text @click="close">Close</v-btn>-->
  <!--        <v-btn color="primary" text @click="submit">Submit</v-btn>-->
</template>
<script>
import { db } from "@/db";
// import { api } from "@/api";
import HiDialog from "@/components/HiDialog";
import Validator from "@/hive/Validator";
import { mapGetters } from "vuex";
export default {
  components: {
    HiDialog
  },
  data() {
    return {
      isOpen: false,
      valid: false,
      name: "",
      midName: "",
      surname: "",
      phone: "",
      email: "",
      group: null,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length > 1) || "Name must be valid"
      ],
      emailRules: [v => Validator.email(v) || "Email must be valid"],
      phoneRules: [
        v => !v || Validator.phoneNumber(v) || "Phone number must be valid."
      ],
      error: null
    };
  },

  methods: {
    open() {
      this.isOpen = true;
    },
    clearForm() {
      this.$refs.form.reset();
      this.error = null;
    },
    async submit() {
      const data = {
        name: this.name,
        midName: this.midName,
        surname: this.surname,
        email: this.email,
        groups: [this.group]
      };
      if (!data.midName || !data.midName.length) data.midName = null;
      if (!data.surname || !data.surname.length) data.surname = null;
      const number = this.phone
        //delete all non-digit except for +
        .replace(/[^\d+]/g, "")
        //replace leading 00
        .replace(/^00/, "+")
        //support incomplete numbers for common mistakes for Australian numbers.
        .replace(/^61/, "+61")
        .replace(/^\+6104/, "+614")
        //support for Chinese mainland as well.
        .replace(/^86/, "+86");

      if (/^(04|\+614)\d{8}$/.test(number)) {
        data.mobile = number.replace(/^04/, "+614");
      } else {
        data.phone = number;
      }
      console.log(data);
      await db.collection("contacts").add(data);
    }
  },
  computed: {
    ...mapGetters("meta", ["contactGroups"])
  }
};
</script>
<style lang="scss" scoped></style>
